import * as Yup from 'yup';

export const resetInitialValues = {
    password: '',
    passwordConfirm: '',
};

export const resetValidation = Yup.object({
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters.')
    .matches(/[A-Z]/, 'Password must contain at least 1 uppercase letter.')
    .matches(/[a-z]/, 'Password must contain at least 1 lowercase letter.')
    .matches(/[0-9]/, 'Password must contain at least 1 number.')
    .matches(/[^a-zA-Z0-9]/, 'Password must contain at least 1 special character.')
    .notOneOf(['#'], 'Password should not contain #.')
    .required('Password is required.'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Required'),
});